<template>
	<section>
		<loading id="spinner" :active="loading" :can-cancel="false" :is-full-page="true"></loading>
		<div class="row">
			<div class="input-field col s12 m3 l3 xl3">
				<select name="edital" v-model="edital" class="browser-default select_sec" @change="carregarFaixas(edital)">
					<option selected disabled value="-1">Escolha o edital</option>
					<option v-for="edital in edits" v-bind:value="edital.id" >Edital {{edital.numero}}/{{edital.ano}}</option>
				</select>
			</div>
		</div>
		
		<div class="row" v-if='faixas.length'>
			<div class="col s16 m6 l6 xl6">
				<table>
					<thead>
						<tr>
							<th>Modalidade</th>
							<th>Faixa</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="modalidade in modalidades">
							<td><b>{{modalidade}}</b></td>
							<td>
								<select class="browser-default  select_sec" :id='modalidade' @change='mudarFaixa(modalidade)'>
									<option selected disabled>Escolha a faixa</option>
									<option v-for="(modalidade, index) in modalidades" :value="index">{{index + 1}}</option>
								</select>
							</td>
							
						</tr>
					</tbody>
				</table>
			</div>
			<div class="col s12 m6 l6 xl6">
				<table>
					<thead>
						<tr>
							<th>Faixa</th>
							<th>Max. Inscrições</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="faixa in faixas">
							<td><b>{{faixa.numero}}</b></td>
							<td>
								<select class="browser-default select_sec" v-model='faixa.max_inscricoes'>
									<option selected disabled>Escolha o max. inscrições</option>
									<option v-for="(inscricao, index) in inscricoes">{{index}}</option>
								</select>
							</td>						
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div v-else>
			<b>Edital anterior à configuração de faixas de modalidades.</b>
		</div>
		<div class="row" v-if='faixas.length'>
            <div class="col s12">
                <button type="button"
                        class="btn waves-effect waves-light indigo"
                        @click.prevent="salvaDados">
                    <i class="material-icons left">save</i>
                    Salvar
                </button>
            </div>
        </div>
	</section>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
	name: "VueConfiguracaoFaixas",
	components: {Loading},
	props: ['editais'],
	data() {
		return {
			edits: JSON.parse(this.editais),
            loading: false,
			edital: JSON.parse(this.editais)[0].id,
			faixas: [],
			modalidades: ['Curso', 'Evento', 'Programa', 'Projeto'],
			inscricoes: Array.apply(null, Array(5)),
		}
	},
	methods: {
		async carregarFaixas() {
			this.loading = true;
			await this.$http.get('/api/configuracoes-faixas/' + this.edital).then((req) => {this.faixas = req.body;});		
			this.loading = false;
		},
		async salvaDados() {
			var faixas = this.faixas,
			    i = faixas.length,
				num = 0,
				valor;
				
			while (--i >= 0) {
				valor = faixas[i].modalidades.length;
				if (valor && !faixas[i].max_inscricoes) {
					Swal.fire({ title: 'Ocorreu um erro!', text: 'Faixas com modalidades precisam de pelo menos 1 inscrição!', icon: 'error'})
					return;
				}
				num += valor;
			}
			
			if (num < faixas.length) {
				Swal.fire({ title: 'Ocorreu um erro!', text: 'Todas as modalidades precisam estar em uma faixa!', icon: 'error'})
				return;
			}
			
			this.loading = true;

			await this.$http.put('/api/configuracoes-faixas/', this.faixas).then(response => {
				Swal.fire('Sucesso!', 'Faixas configuradas com sucesso!', 'success')
			});

			this.loading = false;
		},
		mudarFaixa(modalidade) {
			var faixa = document.getElementById(modalidade).value,
				faixas = this.faixas,
				i = faixas.length, 
				idx;
				
			while (--i >= 0) {
				idx = faixas[i].modalidades.indexOf(modalidade);
				if (idx >= 0)
					faixas[i].modalidades.splice(idx, 1);
				if (faixa == i)			
					faixas[i].modalidades.push(modalidade);
			}
		},
		configurarFaixas() {
			var faixas = this.faixas,
			    i = faixas.length,
			    j,
				modalidades;

			while (--i >= 0) {	
				j = (modalidades = faixas[i].modalidades).length;
				while (--j >= 0)		
					document.getElementById(modalidades[j]).value = faixas[i].numero - 1;
			}
		}
	},
	mounted() {
        this.carregarFaixas(this.edital);
    },
	updated() {
		this.configurarFaixas();
	}
	
}
</script>
